import {
  ArrowPathIcon,
  PlusIcon,
  SparklesIcon
} from "@heroicons/react/24/outline";
import BroadcastClearTranslationsButton from "./BroadcastClearTranslationsButton";

interface BroadcastTranslationsToolbarProps {
  generating: boolean;
  isStale: boolean;
  hasSource: boolean;
  rowCount: number;
  onGenerate: () => void;
  onAdd: () => void;
  onClear: () => void;
}

const BroadcastTranslationsToolbar: React.FC<
  BroadcastTranslationsToolbarProps
> = ({
  generating,
  isStale,
  hasSource,
  rowCount,
  onGenerate,
  onAdd,
  onClear
}) => {
  const generateLabel = generating
    ? "Duke gjeneruar..."
    : isStale
    ? "Rigjenero për të gjitha gjuhët"
    : "Gjenero për të gjitha gjuhët";

  return (
    <div className="flex items-start justify-between mb-1 gap-4">
      <h2 className="text-base font-medium">Përkthimet (opsionale)</h2>
      <div className="flex items-center gap-4 shrink-0">
        <button
          type="button"
          disabled={generating || !hasSource}
          onClick={onGenerate}
          title={
            hasSource
              ? "Gjeneron përkthime për gjuhët që nuk kanë tekst"
              : "Plotësoni titullin dhe përmbajtjen e mesazhit kryesor"
          }
          className="flex items-center gap-1 text-sm font-semibold text-primary
            disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {generating ? (
            <ArrowPathIcon className="w-4 h-4 animate-spin" />
          ) : (
            <SparklesIcon className="w-4 h-4" />
          )}
          {generateLabel}
        </button>
        <button
          type="button"
          className="flex items-center gap-1 text-sm font-semibold text-primary"
          onClick={onAdd}
        >
          <PlusIcon className="w-4 h-4" />
          Shto përkthim
        </button>
        {!!rowCount && (
          <BroadcastClearTranslationsButton
            count={rowCount}
            onConfirm={onClear}
          />
        )}
      </div>
    </div>
  );
};

export default BroadcastTranslationsToolbar;
